import { render, staticRenderFns } from "./CustomerCoachTasks.vue?vue&type=template&id=a863fc52&scoped=true"
import script from "./CustomerCoachTasks.vue?vue&type=script&lang=ts"
export * from "./CustomerCoachTasks.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCoachTasks.vue?vue&type=style&index=0&id=a863fc52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a863fc52",
  null
  
)

export default component.exports